<template>
    <nav id="navbar">
        <div class="tringo-toggle" :class="{ hidden: !state.showInfoButton }">
            <div class="info" @click="toggleInfo"></div>
            <span class="spanInfoButton">Shows/Hides Tringo and instructions</span>
        </div>
        <div class="logo">
           <router-link to="/"><img src="../assets/DigiLogo.png" alt="TrigendaDigi"></router-link>
        </div>
        <div class="links">
            <!-- Show if not logged in -->
            <!--<router-link v-if="state.loggedUser===null" to="/login"><p>Kirjaudu</p></router-link>-->
            <!-- Show if logged in -->
            <span class="navText" v-if="state.loggedUser!==null">{{ state.loggedUser }}</span>
            <a class="navText" v-if="state.loggedUser!==null" @click="logOut">Kirjaudu ulos</a>
        </div>
    </nav>
</template>

<script>
import { reactive, watch } from 'vue';
import { useStore } from 'vuex'

export default {
    name: 'Navbar',
    props: {
        showInfoButton: Boolean
    },
    setup(props, { emit }) {
        const state = reactive({ showInfo: true, loggedUser: null, showInfoButton: props.showInfoButton });
        const store = useStore();

        // Set loggedUser from Vuex store
        state.loggedUser = store.state.loggedUser;

        // Set loggedUser from Vuex store when it changes in Vuex store
        watch(() => store.state.loggedUser,
            (newValue) => {
                state.loggedUser = newValue;
            }
        );

        // Show/hide Info button based on props.showInfoButton value
        watch(() => props.showInfoButton,
            (newValue) => {
                state.showInfoButton = newValue;
            }
        );

        const toggleInfo = () => {
            if (state.showInfo === true)
                state.showInfo = false;
            else
                state.showInfo = true;

            emit('toggleInfo', state.showInfo);
        }

        // Empty Vuex loggedUser and delete token cookie
        const logOut = () => {
            store.commit('setLoggedUser', null);
            document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
        }

        function checkScreenWidth() {
            toggleInfo();
        }

        const x = window.matchMedia("(max-width: 700px)");
        x.addListener(checkScreenWidth);

        return { state, toggleInfo, logOut };
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
    font-size: 1.4em;
}

.navText {
    color: white;
}

nav {
    display: flex;
    flex: auto auto auto;
    justify-content: space-between;
    background-color: #444;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 8%;
    overflow: hidden;
    z-index: 100;
    border-bottom: 0.7vh solid #76B2BA;
}

nav > * {
    flex: auto auto auto;
}

.links {
    position: relative;
    left: 0;
    padding: 0 20px;
}

.links {
    width: 20em;
    padding: 0px;
}
.links p {
    font-size: 2vh;
    margin-top: 2.8vh;
    float: right;
    margin-right: 1vw;
}

.logo {
    height: 100%;
}

.logo img {
    height: 70%;
    margin-top: 7.8%;
}

nav > a {
    color: white;
    text-decoration: none;
    padding: 1em 3em;
    margin: 0 0.1em;
    width: 10em;
    font-size: 1em;
}

nav a:hover {
    color: var(--btn_hover);
}

a {
    color: white;
}
.tringo-toggle {
    width: 20em;
    display: flex;
    align-items: center;
}
.info:hover + .spanInfoButton{
    transition: opacity 200ms ease-out;
    visibility: visible;
    opacity: 1;
}
.info:hover {
    cursor: pointer;
}
.info {
    background: url("../assets/info-icon.png") no-repeat;
    background-size: contain;
    height: 40%;
    width: 6%;
    margin: 0 0 0 0.5vw;
    min-width: 32px;
}

.hidden {
    visibility: hidden;
}

.spanInfoButton {
    font-size: 1em;
    padding: 0 0 0 0.2vw;
    visibility: hidden;
    opacity: 0;
    color: white;
}

        @media only screen and (max-width: 800px) {
        .spanInfoButton {
        font-size: 0.6em;
        }
    }

</style>
